// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"xY-z","inlineTitle":"yY-z","sponsoredAdsWrapper":"zY-z","marketplaceRecosWrapper":"AY-z"};